<template>

    <div class="login-page-wrapper"> <!--:style="loginCssVariables"-->
<login-dialog :login-config="loginConfig"></login-dialog>        
    </div>
</template>

<script>
  import LoginDialog from '../components/login/LoginDialog'
  export default {
    name: 'LoginPage',
    components: { LoginDialog },
    computed: {
      loginConfig() {
        return this.$store.getters.loginConfig
      },
      loginCssVariables() {
        return this.$store.getters.loginCssVariables
      },
    },
    created() {
      this.initLoginConfig()
    },
    methods: {
      async initLoginConfig() {
        await this.$store.dispatch('initApiBaseURL')
        await this.$store.dispatch('loadLoginConfig')
      },
    },
  }
</script>

<style scoped>

</style>
